var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragdrap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2084 19.3751H16.7917V11.6251H20.6667L15.5 5.16675L10.3334 11.6251H14.2084V19.3751Z",
    fill: "#bb86fc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8334 23.2499H5.16671V14.2083H2.58337V23.2499C2.58337 24.6746 3.742 25.8333 5.16671 25.8333H25.8334C27.2581 25.8333 28.4167 24.6746 28.4167 23.2499V14.2083H25.8334V23.2499Z",
    fill: "#bb86fc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdrap);
export default __webpack_public_path__ + "static/media/dragdrap.747aa2d0d94eb16b92c4bff598cd76d9.svg";
export { ForwardRef as ReactComponent };